import { BreakpointsStateInterface } from '../types/breakpoints-state'

export const defaultBreakpoints: BreakpointsStateInterface = {
  isXS: false,
  isSM: false,
  isMD: false,
  isLG: false,
  isXL: false,
  is2XL: false,
}
